<template>
  <div>
    <div style="display: flex; align-items: center; margin: 30px 40px;">
      <van-image src="https://img1.baidu.com/it/u=2101556152,538604057&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500" round
        width="5.5rem" height="5.5rem">
        <template v-slot:error>加载失败</template>
      </van-image>
      <span style="margin-left: 20px; font-weight: bold; font-size: 20px;">{{ username }}</span>
      <wd-button type="icon" icon="wd-icon-edit-outline" @click="confirmq"></wd-button>
    </div>
    <div>
      <wd-notice-bar text="如遇到'未填写'情况请点击输入您的个人信息,谢谢合作" prefix="warn-bold" type="danger"
        style="font-size: 15px;"></wd-notice-bar>
    </div>
    <div class="text_gr" style="margin-top: 15px;">
      <wd-card style="box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2); transition: 0.3s;  position: relative;">
        <div
          style="background-color: #FFFFFF; border-radius: 10px;  margin: 5px; display: inline-block; text-align: center; padding-left: 20px;">
          <van-icon name="friends-o" size="40" color="#1989fa" style="margin-left: 5px;"></van-icon>
          <h2 style="color: black; margin: 0; margin-left: 5px;">真实姓名</h2>
          <span style="font-weight: bold; font-size: 15px;" @click="confirms">{{ msg }}</span>
        </div>
        <div
          style=" background-color: #FFFFFF; border-radius: 10px;  margin: 5px; position: absolute; right: 0; top:20%; padding-right: 40px; display: flex; flex-direction: column; align-items: center; text-align: center;">
          <van-icon name="phone-o" size="40" color="#1989fa" style="margin-left: 10px;"></van-icon>
          <h2 style="color: black; margin: 0;">联系方式</h2>
          <span style=" font-weight: bold; font-size: 15px;" @click="confirm">{{ msgs }}</span>
        </div>
      </wd-card>
    </div>

    <div style="margin-top: 20px;">
      <wd-card title="我发布的物品 >">
        <!-- 物品项 -->
        <div class="item">
          <img src="../assets/cat.png" alt="物品图片">
          <div class="details">
            <p style="color: black; font-weight: bold;">一只小猫</p>
            <p style="color: black;">描述:小猫由于凌晨2点走失</p>
            <p style="font-weight: bold;">认领中</p>
          </div>
          <!-- <button>查看</button> -->
        </div>
        <div class="item">
          <img src="../assets/bird.png" alt="物品图片">
          <div class="details">
            <p style="color: black; font-weight: bold;">隔壁领家一只小鸟</p>
            <p style="color: black;">描述：隔壁小鸟飞进一人家里,后被主人寻回</p>
            <p style="font-weight: bold;">已认领</p>
          </div>
          <!-- <button>查看</button> -->
        </div>
      </wd-card>
    </div>
    <div class="footer">
      <van-tabbar v-model="active">
        <van-tabbar-item icon="home-o" to="/">首页</van-tabbar-item>
        <van-tabbar-item icon="like-o" to="/Pay">关注</van-tabbar-item>
        <van-tabbar-item icon="comment-o " to="/Hall">大厅</van-tabbar-item>
        <van-tabbar-item icon="manager-o" to="MyLogin">我的</van-tabbar-item>
      </van-tabbar>
    </div>
  </div>
</template>

<script>
export default {
  name: "MyLogin",
  data() {
    return {
      active: 3,
      msg: "未填写",
      msgs: "未填写",
      personName: '初始名字',
      isShow: false, // 控制消息框显示的变量
      username: '用户012345', // 存储用户输入的用户名
    }
  },
  methods: {
    confirm() {
      this.$messageBox.prompt('请输入邮箱', {
        inputPattern: /.+@.+\..+/i
      }).then(({ value }) => {
        this.$messageBox.alert(`你输入的邮箱是： ${value}`),
          this.msgs = value
      })
    },
    confirms() {
      this.$messageBox.prompt('请输入您的真实姓名', {
        inputPattern: /^[\u4e00-\u9fa5]+$/,
        inputErrorMessage: '输入必须是中文文字'
      }).then(({ value }) => {
        this.$messageBox.alert(`你的名字是： ${value}`),
          this.msg = value
      })
    },
    showMessageBox() {
      this.isShow = true;
    },
    handleConfirm() {
      this.isShow = false;
      // 这里可以处理确认事件，比如保存数据或发送到服务器
      console.log("Confirmed username:", this.username);
    },
    handleCancel() {
      this.isShow = false;
      console.log("Username input was cancelled.");
    },
    confirmq() {
      this.$messageBox.prompt('请输入用户名', {
        inputPattern: /\S+/  // 确保至少有一个非空白字符
      }).then(({ value }) => {
        if (value) {  // 确认有值被输入
          this.username = value;  // 更新组件的 data 属性
          this.$messageBox.alert(`你输入的用户名：${value}`);
        } else {
          this.$messageBox.alert('输入无效，请输入有效的用户名');
        }
      }).catch(() => {
        this.$messageBox.alert('取消输入');
      });
    }
  }
}
</script>

<style scoped>
.item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

img {
  max-width: 100px;
  margin-right: 20px;
}

.details {
  flex-grow: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/MyLogin.vue